module.exports = __webpack_public_path__ + "static/img/role-en.b1a664c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-en.png
// module id = sv6+
// module chunks = 1